<template>
  <el-row>
    <el-col :span="12">
      <GeocodeUserDisplay :customer="delivery_point.customer"></GeocodeUserDisplay>
      <el-row class="container-border">
        <el-col :span="24" class="clientAddress">
          <p class="value-style bigger">{{ delivery_point.raw_address | applyDecodeRSA }}</p>
          <h3 class="key-style">Dirección no encontrada</h3>
          <p class="value-style">
            {{ delivery_point.point.street.locality.name | capitalizeFirstLetter }} /
            {{ delivery_point.point.street.commune.name | capitalizeFirstLetter }}
          </p>
          <h3 class="key-style">Localidad / Comuna</h3>
          <p class="value-style">{{ delivery_point.point.street.commune.region.name }}</p>
          <h3 class="key-style">Región</h3>
          <div>
            <el-form class="main-form geoForm">
              <el-form-item>
                <span class="label">Buscar por dirección</span>
                <el-tooltip placement="top">
                  <div slot="content">A veces errores en la comuna, region o<br/>
                    faltas ortográficas afectan la búsqueda del punto.<br/>
                    <span class="focus small">
                    ** Busca la dirección re-escribiendo la información recibida. **
                    </span>
                  </div>
                  <i class="tooltipStyle fas fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                  <InputSearchAddress v-model="place"
                                      :disabledForm="switch_on"></InputSearchAddress>
              </el-form-item>
              <el-form-item>
                <span class="label">Buscar por latitud, longitud</span>
                <el-tooltip placement="top">
                  <div slot="content">¿Sabes la locación del punto exacto?<br/>
                    pega la latitud y longitud siguiento el formato<br/>
                    <span class="focus small">
                    ** El formato al pegar es 'lat, lng' **
                  </span>
                  </div>
                  <i class="tooltipStyle fas fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
                  <InputSearchByPosition :value="place"
                                         @setPosition="setPlaceByLocation"></InputSearchByPosition>
              </el-form-item>
              <el-form-item>
                <div>
                  <span class="label">
                    Buscar en otros sitios
                    <el-tooltip placement="top">
                      <div slot="content">
                        ¿No estás seguro de haber encontrado el punto?<br/>
                        Revisa la dirección en otros buscadores<br/>
                        <span class="focus small">
                          ** Luego puedes pegar la 'LAT,LNG' que obtuviste **
                        </span>
                      </div>
                      <i class="tooltipStyle fas fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip>
                  </span>
                  <div class="iconsSitesContainer">
                    <a v-for="(site, index) in sites"
                       :href="site.url"
                       :key="index"
                       target="_blank"
                       class="iconSiteContainer"><img :src="getImgUrl(site.img)" :alt="site.url">
                    </a>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="submit-box">
            <el-form class="submitBtns">
              <el-button v-if="socsMode" class="btn grey" @click="changeAddressNotFound">
                No Encontrado
              </el-button>
              <el-button v-if="!socsMode" class="btn primary" @click="changeAddress">
                Mostrar Otro Punto
              </el-button>
              <el-button v-if="different"
                         class="btn primary" @click="confirmModal">
                <!--@click="verifyCommune"> -->
                Encontrado
              </el-button>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="12">
      <MapByGeo v-model="place"
                :height="'600px'"
                :zoom="zoom"
                :latlng="latlng"
                :draggableMarker="true">
      </MapByGeo>
    </el-col>
    <el-dialog title="Geocodificación" :visible.sync="dialogFormVisible">
       <span>¿Desea confirmar la dirección escogida?</span>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loadingSetCommune"
                   @click="dialogFormVisible = false">Cancelar</el-button>
        <el-button :loading="loadingSetCommune"
                   type="primary" @click="handleSubmit">Confirmar</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { tenantSites } from '@/mixins/tenants';
import { apiRequest } from '../../backend/vue-axios/axios';
import { decodeRSA } from '../../mixins/function';
import GeocodeUserDisplay from './GeocodeUserDisplay.vue';
import InputSearchAddress from './maps/InputSearchAddress.vue';
import InputSearchByPosition from './maps/InputSearchByPosition.vue';
import MapByGeo from './maps/MapByGeo.vue';
import { getRumDuration, startRumTiming, trackBusinessFlow } from '@/observability/datadogRum';

export default {
  name: 'GeocodeAssistV2',
  components: {
    GeocodeUserDisplay,
    InputSearchAddress,
    InputSearchByPosition,
    MapByGeo,
  },
  data() {
    return {
      errors: {
        searchDir: false,
      },
      switch_on: false,
      loadingSetCommune: false,
      dialogFormVisible: false,
      latlng: {},
      localityPoints: {},
      zoom: 10,
      place: {
        address: '',
        position: {
          lat: -33.435774,
          lng: -70.660690,
        },
        commune: '',
        locality: '',
        route: '',
        street_number: '',
      },
      changedCommune: false,
      submitLoading: false,
      newCommune: '',
      switchCommune: false,
      actualCommune: '',
      position: '',
      sites: [],
    };
  },
  props: {
    delivery_point: Object,
    socsMode: Boolean,
  },
  filters: {
    applyDecodeRSA(data) {
      return decodeRSA(data);
    },
    capitalizeFirstLetter(string) {
      const low = string.toLocaleString();
      return low.charAt(0).toUpperCase() + low.slice(1).toLowerCase();
    },
  },
  mounted() {
    this.sites = tenantSites();
  },
  computed: {
    different() {
      if (this.place.position.lat !== this.localityPoints.lat) {
        return true;
      }
      return false;
    },
  },
  methods: {
    confirmModal() {
      this.dialogFormVisible = true;
    },
    changeAddress() {
      this.$emit('changeAddress');
    },
    setPlaceByLocation(position) {
      this.latlng = JSON.parse(JSON.stringify(position));
    },
    changeAddressNotFound() {
      const params = {
        geo_state_id: 9,
        point: JSON.parse(JSON.stringify(this.initialPoint)),
        commune: '',
      };
      const startedAt = startRumTiming();
      trackBusinessFlow({
        module: 'geocoding',
        flow: 'manual_geocoding',
        action: 'address_not_found_requested',
        status: 'attempt',
        context: {
          point_id: params.point.id,
          geo_state_id: params.geo_state_id,
        },
      });
      apiRequest({
        module: 'geocoding',
        service: 'update_location',
        pathparam: { id: params.point.id },
        params,
      }).then(() => {
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'manual_geocoding',
          action: 'address_not_found_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            point_id: params.point.id,
            geo_state_id: params.geo_state_id,
          },
        });
        this.$emit('updated');
      }).catch(() => {
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'manual_geocoding',
          action: 'address_not_found_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            point_id: params.point.id,
            geo_state_id: params.geo_state_id,
          },
        });
        this.$notify.error({
          title: 'Error',
          message: 'Error al editar punto',
        });
      });
    },
    getImgUrl(img) {
      const images = require.context('../../assets/img/', false);
      return images(`./${img}`);
    },
    isFunction(functionToCheck) {
      return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    },
    setPoint() {
      const { point } = this.delivery_point;
      point.latitude = this.place.position.lat;
      point.longitude = this.place.position.lng;
      return point;
    },
    handleSubmit() {
      const params = {
        geo_state_id: 6,
        point: this.setPoint(),
        locality: this.place.locality,
        route: this.place.route,
        street_number: this.place.street_number,
        commune: this.place.commune,
      };
      const startedAt = startRumTiming();
      trackBusinessFlow({
        module: 'geocoding',
        flow: 'manual_geocoding',
        action: 'manual_update_requested',
        status: 'attempt',
        context: {
          point_id: params.point.id,
          geo_state_id: params.geo_state_id,
          locality: params.locality,
          commune: params.commune,
        },
      });
      apiRequest({
        module: 'geocoding',
        service: 'update_location',
        pathparam: { id: params.point.id },
        params,
      }).then(() => {
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'manual_geocoding',
          action: 'manual_update_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            point_id: params.point.id,
            geo_state_id: params.geo_state_id,
            locality: params.locality,
            commune: params.commune,
          },
        });
        this.$notify({
          type: 'success',
          title: 'Completado',
          message: 'Punto editado con éxito',
        });
        if (sessionStorage.getItem('suborders') !== null) {
          this.$emit('updated');
        }
        this.$emit('changeAddress');
        this.loadingSetCommune = false;
        this.position = '';
      }).catch(() => {
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'manual_geocoding',
          action: 'manual_update_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            point_id: params.point.id,
            geo_state_id: params.geo_state_id,
            locality: params.locality,
            commune: params.commune,
          },
        });
        this.$notify.error({
          title: 'Error',
          message: 'Error al editar punto',
        });
        this.loadingSetCommune = false;
      });
      this.loadingSetCommune = false;
    },
  },
  created() {
    this.initialPoint = JSON.parse(JSON.stringify(this.delivery_point.point));
    this.localityPoints.lat = -33.435774;
    this.localityPoints.lng = -70.660690;
    if (this.delivery_point.point.street.localities_id !== 0) {
      this.localityPoints.lat = this.delivery_point.point.street.locality.latitude;
      this.localityPoints.lng = this.delivery_point.point.street.locality.longitude;
    }
    this.place = {
      address: `${decodeRSA(this.delivery_point.raw_address)}, ${this.delivery_point.point.street.commune.name}`,
      position: {
        lat: this.localityPoints.lat,
        lng: this.localityPoints.lng,
      },
      commune: '',
      locality: '',
    };
  },
};
</script>

<style lang="scss" scoped>
  .submit-box {
    margin-top: 30px;
  }
  .container-border {
    padding: 15px;
    box-sizing: border-box;
    height: 503px;
    overflow: scroll;
  }
  .label {
    text-transform: uppercase;
    font-size: 10px;
    color: #606266;
    display: inline-block;
    text-align: left;
    line-height: 12px;
    vertical-align: bottom;
    font-weight: 700;
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: #AAD500;
    &.small {
      display: block;
      font-style: italic;
      margin-top: 0.5em;
      font-size: 0.85em;
    }
  }
  .switchContainer {
    display: flex;
    justify-content: space-between;
  }
  .tooltipStyle {
    color: #AAD500;
    font-size: 16px;
    vertical-align: bottom;
  }
  .deskContainer {
    width: 100%;
    padding: 10px;
    background: $fb-grey-light-97;
    box-sizing: border-box;
  }
  .clientInfoContainer {
    display: flex;
  }
  .clientIcon {
    height: 71px;
    width: 71px;
    background: white;
    border: 1px solid $fb-grey-light-84;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .fa-user {
      color: $fb-green;
      font-size: 30px;
    }
  }
  .clientInfo {
    width: 100%;
    padding: 10px;
    background: white;
    border: 3px solid #fafafa;
  }
  .errorContainer {
    display: flex;
    align-items: center;
    margin: 10px 0 0 20px;
    .fa-exclamation-circle {
      color: $fb-red;
      font-size: 20px;
      margin-right: 5px;
    }
  }
  .notFoundNotification {
    font-size: 12px;
    font-weight: 700;
  }
  .notFoundProposition {
    font-size: 12px;
    font-weight: 300;
    font-style: italic;
  }
  .key-style {
    font-weight: 700;
    font-size: 10px;
    color: $fb-green;
    margin: 0;
    text-align: left;
    text-transform: uppercase;
    margin-bottom: 15px;
  }
  .value-style {
    font-weight: 300;
    font-size: 16px;
    margin: 0;
    text-align: left;

  }
  .iconsSitesContainer {
    display: flex;
  }
  .iconSiteContainer {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
    }
  }
  .fas.fa-info-circle {
    font-size: 13px;
    margin-left: 5px;
  }
  .el-input {
    margin-top: 1em;
  }
</style>
